'use strict';
const trackingUtils = require('../../../../webapp/static-content/_versionedByRelease_/js/modules/utils/tracking.utils');
const BaseView = require('components-framework/view/base.view');
const {addBookingDataParameters} = require('../../../../webapp/static-content/_versionedByRelease_/js/modules/utils/app_download_links.utils');

module.exports = BaseView.extend({
    initialize() {
        const isDynpack = Odigeo.Utils.isRequestApp('dp');
        this.$el.html(this.templates[this.options.template]({
            keys: this.keys,
            selector: this.options.selector,
            urlButton: this.options.selector + 'Url',
            backgroundStyleTag: this.getStyleAttr(this.options.selector, 'Background'),
            titleClass: 'odf-strong',
            textClass: 'odf-strong odf-p',
            starsImage: this.getStyleAttr(this.options.selector, 'Image'),
            btnClass: this.options.selector === 'resultsbottom'
                || this.options.selector === 'findyourbooking' ? 'odf-btn-sm' : '',
            reduceHeightClass: !isDynpack ? 'od-app-touchpoint-reduced' : '',
        }));
    },

    selectors: {
        appButton: '.app_touchpoint_button',
        appCheckInButton: '.app_touchpoint_checkin_btn',
    },

    events: {
        'tap .app_touchpoint_button': 'onTapAppButton',
        'tap .app_touchpoint_checkin_btn': 'onTapAppCheckInButton',
    },

    onTapAppButton(evt) {
        this.onTapButton(evt, this.selectors.appButton);
    },

    onTapAppCheckInButton(evt) {
        this.onTapButton(evt, this.selectors.appCheckInButton);
    },

    onTapButton(evt, selector) {
        evt.preventDefault();
        this.appCheckInAnalyticsEventTracking();
        if (this.options.bookingData) {
            const url = this.keys[this.options.selector + 'ToAppTripdetailsUrl'];
            location.replace(trackingUtils.decorateAppTouchpointUrl(addBookingDataParameters({baseUrl: url, bookingData: this.options.bookingData})));
        } else {
            location.replace(trackingUtils.decorateAppTouchpointUrl(this.$el.find(selector).data('url')));
        }
    },

    appCheckInAnalyticsEventTracking() {
        trackingUtils.trackEvent(this.options.trackAction, this.options.trackLabel, this.options.trackCategory);
    },

    getStyleAttr(selector, type) {
        let styleAttr = '';
        const styleUrlValue = this.keys[selector + type];
        if (!Odigeo._.isEmpty(styleUrlValue) && type === 'Image') {
            styleAttr = Odigeo.UserArea.brandedImagePath + styleUrlValue;
        } else if (!Odigeo._.isEmpty(styleUrlValue) && type === 'Background') {
            styleAttr = 'style="background-image: url(\'' + Odigeo.UserArea.brandedImagePath + styleUrlValue + '\')"';
        }
        return styleAttr;
    },
});
